export default "__VITE_ASSET__BWSpHOCU__"